<section
  class="board-hero-panel"
	*ngIf="data"
	[ngClass]="{
		'has-bg-image': !!data.backgroundImage?.value
	}"
	#panelElRef>
  <top-wave *ngIf="topWave === true"></top-wave>
	<div [ngClass]="{ 'board-hero-panel__content' : data.media?.value, 'board-hero-panel__content-centered' : !data.media?.value, 'board-hero-panel__content-topwave' : topWave, 'board-hero-panel__content-bottomwave' : bottomWave }">
		<div *ngIf="data.overlayImage?.value"
				 class="board-hero-panel__overlay-img">
			<img [src]="data.overlayImage.value.src"
			 alt="{{ data.overlayImage.value.alt }}"
			 loading="lazy"
			 [ngStyle]="{aspectRatio: data.overlayImage?.value?.width / data.overlayImage?.value?.height}" />
		</div>
		<div [className]="data.media?.value ? 'board-hero-panel__text' : 'board-hero-panel__text-middle'">
			<h1 *ngIf="data.title"
					class="board-hero-panel__title"
					#titleEl
					[innerHTML]="processedTitle | safe"></h1>
			<div class="board-hero-panel__description rte"
					 *ngIf="data.description.value"
					 [innerHTML]="processedDescription | safe" #descriptionEl></div>
			<div *ngIf="data.links?.value"
					 class="board-hero-panel__link"
					 [ngClass]="{
					   'board-hero-panel__link--left-oriented': data.linksOrientation?.value === 'Left side',
					   'board-hero-panel__link--right-oriented': data.linksOrientation?.value === 'Right side'
					 }">
				<app-bg-button *ngFor="let link of data.links.value" [buttonColor]="link.color.value" class="board-hero-panel__button" [data]="link.link.value"></app-bg-button>
			</div>
		</div>
		<div>
			<div *ngIf="hasImage; then imageBlock; else videoBlock "></div>
		</div>
	</div>
  <bottom-wave *ngIf="bottomWave === true"></bottom-wave>
</section>

<ng-template #imageBlock>
	<app-picture class="board-hero-panel__media-holder" *ngIf="hasImage" [data]="media"></app-picture>
</ng-template>

<ng-template #videoBlock>
	<section class="board-hero-panel__media-holder board-hero-panel__media-holder--with-video" *ngIf="videoData">

		<button (click)="open()" class="board-hero-panel__thumbnail" *ngIf="videoData">
			<div class="board-hero-panel__thumbnail-img">
				<img src="{{thumbnailSrc}}" alt="" loading="lazy" />
			</div>
		</button>

		<app-modal-video *ngIf="isShow" [data]="videoData" [isShow]="isShow" (close)="close()"></app-modal-video>
	</section>
</ng-template>
